import { getUserAttribute, UserAttributes } from "../services/authorization";
import { UserTypes } from "shared-types";

export function checkIsFilmmakersProfile() {
  return (
    Number(getUserAttribute(UserAttributes.PublicationCode)) ===
    UserTypes.filmmakersProfile
  );
}
